import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-supervision-fixed-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './supervision-fixed-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supervision-fixed-staff-member.component.scss',
})
export class SupervisionFixedStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() unfix = new EventEmitter<StaffMember>();

}
